import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Calendar, GraduationCap, Github, Linkedin, FileText, Briefcase, Code, Globe, Database, Zap, Clock, Brain } from 'lucide-react';
import { workExperience } from '../data/personalInfo';
import { WakaTimeStatsSection } from './WakaTimeStats';
import LivingNeuralNetwork from './LivingNeuralNetwork';
// import joseph from '../jo-cool.jpeg';
import joseph from '../image.png';

const About = () => {
  const [age, setAge] = useState(0);

  useEffect(() => {
    const date = new Date();
    const birthDate = new Date(2000, 5, 15);
    const calculatedAge = Math.floor((date - birthDate) / 31557600000);
    setAge(calculatedAge);
  }, []);

  const personalInfo = [
    { icon: Mail, label: "Email", value: "josephofilii@gmail.com" },
    { icon: Phone, label: "Phone", value: "+234 706 094 2709" },
    { icon: MapPin, label: "Location", value: "Lagos, Nigeria" },
    { icon: Calendar, label: "Birthday", value: "15 May 2000" },
    { icon: GraduationCap, label: "Degree", value: "B.S.E Computer Science & Engineering" }
  ];

  const socialLinks = [
    {
      icon: Github,
      label: "GitHub",
      url: "https://www.github.com/jayyy123",
      color: "hover:text-gray-900 dark:hover:text-white"
    },
    {
      icon: Linkedin,
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/joseph-ofili/",
      color: "hover:text-blue-600"
    },
    {
      icon: Briefcase,
      label: "Upwork",
      url: "https://www.upwork.com/freelancers/~016333b88d9874e553?viewMode=1",
      color: "hover:text-green-600"
    },
    {
      icon: FileText,
      label: "Resume",
      url: "https://docs.google.com/document/d/1jM3xDvYeyvY18k68SBtupCqG0NFv8QemlWpuGIqnnVA/edit?usp=sharing",
      color: "hover:text-purple-600"
    }
  ];

  return (
    <>
      <section
        id="about"
        style={{
          minHeight: '100vh',
          padding: '120px 0',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Background Animation */}
        <div style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.1
        }}>
          <div style={{
            position: 'absolute',
            top: '20%',
            left: '10%',
            width: '300px',
            height: '300px',
            background: '#60a5fa',
            borderRadius: '50%',
            mixBlendMode: 'multiply',
            filter: 'blur(40px)',
            animation: 'pulse 4s infinite'
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '20%',
            right: '10%',
            width: '400px',
            height: '400px',
            background: '#a855f7',
            borderRadius: '50%',
            mixBlendMode: 'multiply',
            filter: 'blur(40px)',
            animation: 'pulse 4s infinite',
            animationDelay: '2s'
          }}></div>
        </div>

        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 10
        }}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '60px'
            }}
          >
            <h2 style={{
              fontSize: '3.5rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '24px',
              background: 'linear-gradient(135deg, #60a5fa, #a855f7)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              About Me
            </h2>
            <p style={{
              fontSize: '1.125rem',
              color: '#d1d5db',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: 1.6
            }}>
              Get to know more about my journey, experience, and what drives me as a Software Engineer
            </p>
          </motion.div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: window.innerWidth >= 1024 ? '1fr 1fr' : '1fr',
            gap: '60px',
            alignItems: 'center'
          }}>
            {/* Left Column - Image and Personal Info */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div style={{
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '16px',
                padding: '32px',
                textAlign: 'center'
              }}>
                <img
                  src={joseph}
                  alt="Joseph Ofili"
                  style={{
                    width: '200px',
                    height: '200px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginBottom: '24px',
                    border: '4px solid rgba(255, 255, 255, 0.2)'
                  }}
                />
                <h3 style={{
                  fontSize: '1.875rem',
                  fontWeight: 'bold',
                  color: 'white',
                  marginBottom: '16px'
                }}>
                  Joseph Chukwuemeka Ofili
                </h3>
                <p style={{
                  fontSize: '1.125rem',
                  color: '#60a5fa',
                  marginBottom: '24px',
                  fontWeight: '500'
                }}>
                  Software Engineer
                </p>

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  gap: '12px',
                  marginBottom: '24px'
                }}>
                  {personalInfo.map((info, index) => {
                    const IconComponent = info.icon;
                    return (
                      <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        color: '#d1d5db',
                        fontSize: '0.875rem'
                      }}>
                        <IconComponent size={16} />
                        <span style={{ fontWeight: '500' }}>{info.label}:</span>
                        <span>{info.value}</span>
                      </div>
                    );
                  })}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    color: '#d1d5db',
                    fontSize: '0.875rem'
                  }}>
                    <Calendar size={16} />
                    <span style={{ fontWeight: '500' }}>Age:</span>
                    <span>{age} years</span>
                  </div>
                </div>

                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '16px'
                }}>
                  {socialLinks.map((link, index) => {
                    const IconComponent = link.icon;
                    return (
                      <motion.a
                        key={link.label}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '48px',
                          height: '48px',
                          background: 'rgba(255, 255, 255, 0.1)',
                          backdropFilter: 'blur(12px)',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          borderRadius: '8px',
                          color: 'white',
                          textDecoration: 'none',
                          transition: 'all 0.3s ease'
                        }}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                      >
                        <IconComponent size={20} />
                      </motion.a>
                    );
                  })}
                </div>
              </div>
            </motion.div>

            {/* Right Column - Bio and Professional Info */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px'
              }}
            >
              <div style={{
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '16px',
                padding: '32px'
              }}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: 'white',
                  marginBottom: '16px'
                }}>
                  Personal
                </h3>
                <p style={{
                  color: '#d1d5db',
                  lineHeight: 1.6,
                  fontSize: '1rem'
                }}>
                  I'm an avid fan of animes, movies, and DC content. I enjoy TV shows and find relaxation in chess.
                </p>
              </div>
        
              <div style={{
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '16px',
                padding: '32px'
              }}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: 'white',
                  marginBottom: '16px'
                }}>
                  Professional
                </h3>
                <p style={{
                  color: '#d1d5db',
                  lineHeight: 1.6,
                  fontSize: '1rem',
                  marginBottom: '16px'
                }}>
                  With 4+ years of experience as a Software Engineer, I specialize in AI-powered solutions and cloud architecture. I work with cutting-edge technologies including Python, Node.js, React, AWS, and advanced AI/ML frameworks.
                </p>
                <p style={{
                  color: '#d1d5db',
                  lineHeight: 1.6,
                  fontSize: '1rem'
                }}>
                  I'm passionate about building scalable applications, implementing intelligent systems, and continuously expanding my expertise in emerging technologies. Currently working remotely with ManaknightDigital while completing my degree in Computer Science and Engineering.
                </p>

                <div style={{
                  marginTop: '20px',
                  padding: '16px',
                  background: 'rgba(96, 165, 250, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid rgba(96, 165, 250, 0.3)'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '8px'
                  }}>
                    <Zap size={16} style={{ color: '#60a5fa' }} />
                    <span style={{
                      fontSize: '0.875rem',
                      fontWeight: 'bold',
                      color: '#60a5fa'
                    }}>
                      Personal Project in Development
                    </span>
                  </div>
                  <p style={{
                    fontSize: '0.875rem',
                    color: '#d1d5db',
                    lineHeight: 1.5
                  }}>
                    Currently building <strong>FlowForge</strong> - an AI-powered automation platform that eliminates repetitive web tasks for businesses. Turn busywork into automated workflows with intelligent browser automation and natural language commands.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section
        id="skills"
        style={{
          padding: '120px 0',
          background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          position: 'relative'
        }}
      >
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px'
        }}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '60px'
            }}
          >
            <h2 style={{
              fontSize: '3.5rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '24px',
              background: 'linear-gradient(135deg, #60a5fa, #a855f7)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Skills & Expertise
            </h2>
            <p style={{
              fontSize: '1.125rem',
              color: '#d1d5db',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: 1.6
            }}>
              Technologies and tools I work with to build innovative solutions
            </p>
          </motion.div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: window.innerWidth >= 1024 ? 'repeat(3, 1fr)' : window.innerWidth >= 768 ? 'repeat(2, 1fr)' : '1fr',
            gap: '32px'
          }}>
            {[
              {
                title: "Programming Languages",
                icon: <Code size={32} style={{ color: '#60a5fa' }} />,
                skills: ["Python", "Node.js", "JavaScript (ES6+)", "TypeScript", "Kotlin", "Golang", "SQL"]
              },
              {
                title: "Markup & Styling",
                icon: <FileText size={32} style={{ color: '#60a5fa' }} />,
                skills: ["HTML5", "CSS3"]
              },
              {
                title: "Frameworks & Libraries",
                icon: <Globe size={32} style={{ color: '#60a5fa' }} />,
                skills: ["Express.js", "Flask", "React", "React Native", "Sequelize", "EJS", "Bootstrap", "Tailwind CSS"]
              },
              {
                title: "Databases & Cloud",
                icon: <Database size={32} style={{ color: '#60a5fa' }} />,
                skills: ["MySQL", "PostgreSQL", "MongoDB", "Firebase", "Redis", "Vector Databases", "AWS (Lambda, EC2, RDS, S3)", "Docker", "Jenkins"]
              },
              {
                title: "AI & Machine Learning",
                icon: <Zap size={32} style={{ color: '#60a5fa' }} />,
                skills: ["OpenAI GPT Series", "Claude", "Groq Llama Models", "Gemini", "RAG Systems", "Deepgram", "ElevenLabs", "Whisper", "Computer Vision", "NLP"]
              },
              {
                title: "Integrations & APIs",
                icon: <Github size={32} style={{ color: '#60a5fa' }} />,
                skills: ["Stripe (Payments, Connect)", "Hubspot CRM", "Authorize.net", "Eukapay", "Twilio", "Telnyx", "OAuth", "RESTful APIs", "GraphQL"]
              },
              {
                title: "Development Tools",
                icon: <Code size={32} style={{ color: '#60a5fa' }} />,
                skills: ["Git", "GitHub", "VS Code", "Postman", "Figma", "Webpack", "NPM/Yarn"]
              }
            ].map((category, index) => (
              category.title === "Development Tools" ? (
                <motion.div
                  key={category.title}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '16px',
                    padding: '32px',
                    textAlign: 'center'
                  }}
                  whileHover={{ scale: 1.02 }}
                >
                  <div style={{
                    marginBottom: '16px'
                  }}>
                    {category.icon}
                  </div>
                  <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                    color: 'white',
                    marginBottom: '20px'
                  }}>
                    {category.title}
                  </h3>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px',
                    justifyContent: 'center',
                    marginBottom: '20px'
                  }}>
                    {category.skills.map((skill, i) => (
                      <span key={i} style={{
                        background: 'rgba(168, 85, 247, 0.2)',
                        color: '#a855f7',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '0.75rem',
                        fontWeight: '500'
                      }}>
                        {skill}
                      </span>
                    ))}
                  </div>

                  {/* Wakatime Stats */}
                  <div style={{
                    marginTop: '20px',
                    padding: '16px',
                    background: 'rgba(0, 0, 0, 0.3)',
                    borderRadius: '8px'
                  }}>
                    <h4 style={{
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      color: 'white',
                      marginBottom: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <Clock size={16} />
                      Coding Activity (Real-time)
                    </h4>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: '12px'
                    }}>
                      <div style={{
                        background: 'rgba(96, 165, 250, 0.2)',
                        padding: '12px',
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}>
                        <div style={{
                          fontSize: '0.875rem',
                          color: '#60a5fa',
                          marginBottom: '8px',
                          fontWeight: '500'
                        }}>
                          Languages Used (7 Days)
                        </div>
                        <img
                          src="https://wakatime.com/share/@Jokeseph/517f2f6d-2ee1-4012-9195-829bb623c2d7.svg"
                          alt="Language usage statistics"
                          style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '120px',
                            borderRadius: '4px'
                          }}
                        />
                      </div>
                      <div style={{
                        background: 'rgba(168, 85, 247, 0.2)',
                        padding: '12px',
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}>
                        <div style={{
                          fontSize: '0.875rem',
                          color: '#a855f7',
                          marginBottom: '8px',
                          fontWeight: '500'
                        }}>
                          Total Coding Time
                        </div>
                        <img
                          src="https://wakatime.com/badge/user/1a29077c-352e-4138-ae85-58f8b053a010.svg"
                          alt="Total coding time"
                          style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '200px',
                            borderRadius: '4px'
                          }}
                        />
                      </div>
                    </div>

                  </div>
                </motion.div>
              ) : (
                <motion.div
                  key={category.title}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '16px',
                    padding: '32px',
                    textAlign: 'center'
                  }}
                  whileHover={{ scale: 1.02 }}
                >
                  <div style={{
                    marginBottom: '16px'
                  }}>
                    {category.icon}
                  </div>
                  <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                    color: 'white',
                    marginBottom: '20px'
                  }}>
                    {category.title}
                  </h3>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px',
                    justifyContent: 'center'
                  }}>
                    {category.skills.map((skill, skillIndex) => (
                      <span
                        key={skillIndex}
                        style={{
                          background: 'rgba(96, 165, 250, 0.2)',
                          color: '#60a5fa',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontSize: '0.875rem',
                          fontWeight: '500',
                          border: '1px solid rgba(96, 165, 250, 0.3)'
                        }}
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </motion.div>
              )
            ))}
          </div>
        </div>
      </section>

      {/* Neural Network Visualization Section */}
      <section
        id="neural-network"
        style={{
          padding: '120px 0',
          background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          position: 'relative'
        }}
      >
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px'
        }}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '60px'
            }}
          >
            <h2 style={{
              fontSize: '3.5rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '24px',
              background: 'linear-gradient(135deg, #60a5fa, #a855f7)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              <Brain size={48} style={{
                display: 'inline-block',
                marginRight: '16px',
                color: '#ff6b35',
                verticalAlign: 'middle'
              }} />
              AI-Powered Skill Network
            </h2>
            <p style={{
              fontSize: '1.125rem',
              color: '#d1d5db',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: 1.6
            }}>
              Explore my interconnected skills through this interactive 3D neural network.
              Each node represents a technology I work with, connected by real project relationships.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '20px',
              padding: '20px',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
            }}
          >
            <LivingNeuralNetwork isGateway={false} />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            style={{
              textAlign: 'center',
              marginTop: '40px'
            }}
          >
            <div style={{
              display: 'grid',
              gridTemplateColumns: window.innerWidth >= 768 ? 'repeat(3, 1fr)' : '1fr',
              gap: '24px',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              <div style={{
                background: 'rgba(255, 107, 53, 0.1)',
                border: '1px solid rgba(255, 107, 53, 0.3)',
                borderRadius: '12px',
                padding: '20px',
                textAlign: 'center'
              }}>
                <div style={{
                  fontSize: '2rem',
                  marginBottom: '8px'
                }}>🎯</div>
                <div style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#ff6b35',
                  marginBottom: '4px'
                }}>Interactive</div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#d1d5db'
                }}>Click nodes to explore</div>
              </div>

              <div style={{
                background: 'rgba(96, 165, 250, 0.1)',
                border: '1px solid rgba(96, 165, 250, 0.3)',
                borderRadius: '12px',
                padding: '20px',
                textAlign: 'center'
              }}>
                <div style={{
                  fontSize: '2rem',
                  marginBottom: '8px'
                }}>🔗</div>
                <div style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#60a5fa',
                  marginBottom: '4px'
                }}>Connected</div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#d1d5db'
                }}>Real project relationships</div>
              </div>

              <div style={{
                background: 'rgba(168, 85, 247, 0.1)',
                border: '1px solid rgba(168, 85, 247, 0.3)',
                borderRadius: '12px',
                padding: '20px',
                textAlign: 'center'
              }}>
                <div style={{
                  fontSize: '2rem',
                  marginBottom: '8px'
                }}>🚀</div>
                <div style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#a855f7',
                  marginBottom: '4px'
                }}>Dynamic</div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#d1d5db'
                }}>Live animations & effects</div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section
        id="experience"
        style={{
          padding: '120px 0',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
          position: 'relative'
        }}
      >
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px'
        }}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '60px'
            }}
          >
            <h2 style={{
              fontSize: '3.5rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '24px',
              background: 'linear-gradient(135deg, #60a5fa, #a855f7)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Work Experience
            </h2>
            <p style={{
              fontSize: '1.125rem',
              color: '#d1d5db',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: 1.6
            }}>
              My professional journey and key achievements across different roles and companies
            </p>
          </motion.div>

          <div style={{
            display: 'grid',
            gap: '32px'
          }}>
            {workExperience.map((exp, index) => (
              <motion.div
                key={exp.id}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(12px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '16px',
                  padding: '40px',
                  position: 'relative'
                }}
                whileHover={{ scale: 1.01 }}
              >
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: window.innerWidth >= 768 ? '200px 1fr' : '1fr',
                  gap: '32px',
                  alignItems: 'start'
                }}>
                  <div style={{
                    textAlign: window.innerWidth >= 768 ? 'right' : 'left'
                  }}>
                    <div style={{
                      fontSize: '1.125rem',
                      fontWeight: 'bold',
                      color: '#60a5fa',
                      marginBottom: '8px'
                    }}>
                      {exp.duration}
                    </div>
                    <div style={{
                      fontSize: '0.875rem',
                      color: '#d1d5db',
                      textTransform: 'uppercase',
                      letterSpacing: '1px'
                    }}>
                      {exp.type}
                    </div>
                  </div>

                  <div>
                    <h3 style={{
                      fontSize: '1.5rem',
                      fontWeight: 'bold',
                      color: 'white',
                      marginBottom: '8px'
                    }}>
                      {exp.position}
                    </h3>
                    <h4 style={{
                      fontSize: '1.125rem',
                      color: '#a855f7',
                      marginBottom: '16px',
                      fontWeight: '500'
                    }}>
                      {exp.company} • {exp.location}
                    </h4>
                    <p style={{
                      color: '#d1d5db',
                      lineHeight: 1.6,
                      marginBottom: '24px',
                      fontSize: '1rem'
                    }}>
                      {exp.description}
                    </p>

                    <div style={{
                      marginBottom: '24px'
                    }}>
                      <h5 style={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                        marginBottom: '12px'
                      }}>
                        Key Achievements:
                      </h5>
                      <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0
                      }}>
                        {exp.achievements.map((achievement, i) => (
                          <li key={i} style={{
                            color: '#d1d5db',
                            marginBottom: '8px',
                            paddingLeft: '20px',
                            position: 'relative',
                            lineHeight: 1.6
                          }}>
                            <span style={{
                              position: 'absolute',
                              left: 0,
                              color: '#60a5fa',
                              fontWeight: 'bold'
                            }}>
                              •
                            </span>
                            {achievement}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div>
                      <h5 style={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                        marginBottom: '12px'
                      }}>
                        Technologies Used:
                      </h5>
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px'
                      }}>
                        {exp.technologies.map((tech, i) => (
                          <span key={i} style={{
                            background: 'rgba(168, 85, 247, 0.2)',
                            color: '#a855f7',
                            padding: '4px 12px',
                            borderRadius: '16px',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            border: '1px solid rgba(168, 85, 247, 0.3)'
                          }}>
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            style={{
              textAlign: 'center',
              marginTop: '60px'
            }}
          >
            <a
              href="https://docs.google.com/document/d/1jM3xDvYeyvY18k68SBtupCqG0NFv8QemlWpuGIqnnVA/edit?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                background: 'rgba(96, 165, 250, 0.2)',
                color: '#60a5fa',
                padding: '16px 32px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '500',
                border: '1px solid rgba(96, 165, 250, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(96, 165, 250, 0.3)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(96, 165, 250, 0.2)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <FileText size={20} />
              View Full Resume
            </a>
          </motion.div>
        </div>
      </section>

      {/* Live Coding Stats Section */}
      <section
        id="coding-stats"
        style={{
          padding: '80px 0',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)'
        }}
      >
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px'
        }}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '60px'
            }}
          >
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '16px'
            }}>
              📊 Live Coding Analytics
            </h2>
            <p style={{
              fontSize: '1.125rem',
              color: '#d1d5db',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Real-time insights from my development activity powered by WakaTime
            </p>
          </motion.div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: window.innerWidth >= 1024 ? '1fr 1fr' : '1fr',
            gap: '40px',
            alignItems: 'start'
          }}>
            {/* Language Stats */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '16px',
                padding: '32px'
              }}
            >
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: 'white',
                marginBottom: '24px',
                textAlign: 'center'
              }}>
                🔥 Language Usage (Last 7 Days)
              </h3>

              {/* Use the new WakaTime component with real live data */}
              <WakaTimeStatsSection showLanguages={true} showBadge={false} showTitle={false} />

              {/* All hardcoded stats removed - now using real WakaTime data above */}
            </motion.div>

            {/* Activity Summary */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '16px',
                padding: '32px'
              }}
            >
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: 'white',
                marginBottom: '24px',
                textAlign: 'center'
              }}>
                ⚡ Activity Summary
              </h3>

              <div style={{
                display: 'grid',
                gap: '20px'
              }}>
                {/* Weekly Coding Activity */}
                <div style={{
                  background: 'rgba(96, 165, 250, 0.1)',
                  borderRadius: '12px',
                  border: '1px solid rgba(96, 165, 250, 0.3)',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    padding: '16px',
                    borderBottom: '1px solid rgba(96, 165, 250, 0.2)'
                  }}>
                    <h4 style={{
                      color: '#60a5fa',
                      margin: 0,
                      fontSize: '1rem',
                      fontWeight: 'bold'
                    }}>
                      📊 Weekly Activity (7 Days)
                    </h4>
                  </div>
                  <div style={{ padding: '16px' }}>
                    <figure style={{
                      margin: 0,
                      background: 'transparent'
                    }}>
                      <embed
                        src="https://wakatime.com/share/@Jokeseph/b6fb000c-2961-4299-b38e-de16fddb36c1.svg"
                        style={{
                          width: '100%',
                          height: 'auto',
                          minHeight: '200px',
                          borderRadius: '8px'
                        }}
                      />
                    </figure>
                  </div>
                </div>

                {/* Total Coding Time Badge */}
                <div style={{
                  textAlign: 'center',
                  padding: '20px',
                  background: 'rgba(168, 85, 247, 0.1)',
                  borderRadius: '12px',
                  border: '1px solid rgba(168, 85, 247, 0.3)'
                }}>
                  <h4 style={{
                    color: '#a855f7',
                    margin: '0 0 16px 0',
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}>
                    ⏱️ Total Coding Time
                  </h4>
                  <div style={{
                    display: 'inline-block',
                    background: 'white',
                    borderRadius: '8px',
                    padding: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                  }}>
                    <img
                      src="https://wakatime.com/badge/user/1a29077c-352e-4138-ae85-58f8b053a010.svg"
                      alt="Total time coded since Mar 1 2022"
                      style={{
                        height: 'auto',
                        maxWidth: '100%'
                      }}
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;